import { toast } from "react-toastify";
import useSendOTP from "./hook/useSendOTP";
import OTPModal from "./OTPModal";
import VerificationModal from "./verificationModal";
import { OTPTypes } from "./types";
import { useSelector } from "react-redux";

interface OTPProps {
  mobile: number;
  hasError?: boolean;
  extraData?: any;
  onSendOTP?: () => void;
  modals: OTPTypes;
  setModals: React.Dispatch<React.SetStateAction<OTPTypes>>;
  showBtn?: boolean;
  handleSendOTP?: any;
  handleCheckOTP?: any;
  isCustom?:boolean
}

function OTP({
  mobile,
  hasError,
  extraData,
  modals,
  setModals,
  showBtn = true,
  handleSendOTP,
  handleCheckOTP,
  isCustom
}: OTPProps) {

  const { sendOTP } = useSendOTP({ setModals });
  const { customerId } = useSelector((state: any) => state.OTP);

  return (
    <>
      {!customerId && showBtn && (
        <button
          type="button"
          onClick={() =>
            !hasError && mobile
              ? setModals({ ...modals, verificationModal: true })
              : toast.warning("مقادیر را بدرستی وارد کنید")
          }
          className="text-left text-[#007AFF]  cursor-pointer float-left relative bottom-2"
        >
          ارسال کد اعتبار سنجی
        </button>
      )}

      {modals.verificationModal && !hasError && (
        <VerificationModal
          open={modals.verificationModal}
          setOpen={setModals}
          mobile={mobile}
          sendOTP={(newMobile)=>!!handleSendOTP ? handleSendOTP(newMobile) : sendOTP(newMobile)}
          hasEdit={isCustom}
        />
      )}

      {modals.OTPModal && (
        <OTPModal
          open={modals.OTPModal}
          setOpen={() => setModals({ ...modals, OTPModal: false })}
          extraData={extraData}
          handleSendOTP={handleSendOTP}
          handleCheckOTP={handleCheckOTP}
          isCustom={isCustom}
        />
      )}
    </>
  );
}

export default OTP;
